import { render, staticRenderFns } from "./AddImageDialog.vue?vue&type=template&id=3f9910d2&scoped=true"
import script from "./AddImageDialog.vue?vue&type=script&lang=js"
export * from "./AddImageDialog.vue?vue&type=script&lang=js"
import style0 from "./AddImageDialog.vue?vue&type=style&index=0&id=3f9910d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9910d2",
  null
  
)

export default component.exports